module.exports = __webpack_public_path__ + "img/1970East-059_WEB-min.14dea1c0.jpg";